module.exports = __webpack_public_path__ + "img/x-icon.2d9b58ec.png";